let apidaePrestasTriFilters = {

    props: {
        showFiltreTri: Number,
        triFilters: Array,
        tri: Array
    },
    computed: {

    },
    components: {

    },
    directives: {

    },
    data() {
        return {

        }
    },
    methods: {
        trifilterevent() {
            this.$root.callfilters(event)
        },
    },
    template: `
        <div class="tri" v-if="showFiltreTri">
            <span>Trié par :</span>
            <select name="tri" id="tri" class="trifilterevent" @change="trifilterevent()">
                <option v-for="triFilter in triFilters" :value="triFilter.value" :selected="triFilter.value == tri ? 'selected':''">{{ triFilter.label }}</option>
            </select>
        </div>`
}
